import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getComentariosValidacion = async (tokenCita) => {

  if(!tokenCita) return null;

  const query = `
    query AllCitas($tokenCita:String) {
      allCitas(tokenCita: $tokenCita) {
        cita {
          id
          token
          comentariovalidacioncitaSet {
            id
            token
            comentario
            estadoComentario
            ultimoCambio
            usuarioCreador {
              id
              username
              firstName
              lastName
            }
          }
        }
        total
        status
        message
      }
    }
  `;

  const variables = {
    tokenCita
  }

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allCitas;
    if(response2.status !== 'success') return null;
    
    const data = response2.cita[0]?.comentariovalidacioncitaSet;
    return data;

  }catch(error){
    console.error('Error al obtener comentarios de la cita', error);
    return null;
  }
}

const updateComentarioValidacion = async (tokenCita, dataComentario) => {

  if(!tokenCita){
    console.error('token cita es requerido');
    return null;
  }

  const query = `
    mutation SaveComentarioValidacionCita(
      $tokenCita        : String!
      $tokenComentario  : String
      $comentario       : String
      $estadoComentario : String
    ) {
      saveComentarioValidacionCita(
        tokenCita        : $tokenCita,
        tokenComentario  : $tokenComentario,
        comentario       : $comentario,
        estadoComentario : $estadoComentario
      ) {
        status
        message
        comentario {
          id
          token
        }
      }
    }

  `;

  const variables = {
    tokenCita,
    tokenComentario  : dataComentario.token      || '',
    comentario       : dataComentario.comentario || '',
    estadoComentario : dataComentario.estado     || '' 
  }


  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    console.log('response guardarComentario', response);

    const response2 = response.data.data.saveComentarioValidacionCita;
    if(response2.status !== 200) return null;

    const data = response2.comentario;
    return data;

  }catch(error){
    console.error('Error al guardar data de comentario', error);
    return null;
  }

}


export const citasValidacionesService = {
  getComentariosValidacion,

  updateComentarioValidacion
}